import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io('/', { transports: ['websocket', 'polling'] });
  }
  return socket;
}

export function joinProblemRoom(problemId: string) {
  getSocket().emit('join_problem', problemId);
}

export function leaveProblemRoom(problemId: string) {
  getSocket().emit('leave_problem', problemId);
}

export function joinAttemptRoom(attemptId: string) {
  getSocket().emit('join_attempt', attemptId);
}

export function leaveAttemptRoom(attemptId: string) {
  getSocket().emit('leave_attempt', attemptId);
}
